import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SerialStepForm from "../../components/register/SerialStepForm";
import { RegistrationDraftStore } from "../../store/store";
import {
  isValidProjectorSerial,
  PROJECTOR_SERIAL_MAX,
  PROJECTOR_SERIAL_MIN,
} from "../../lib/serial";
import { paths } from "../paths";
import sernoImage from "../../images/X20/serial-no/epson-serial-no.png";

export default function ProjectorSerialStep() {
  const navigate = useNavigate();
  const setEpsonSerial = RegistrationDraftStore((s) => s.setEpsonSerial);
  const existing = RegistrationDraftStore((s) => s.epsonSerialNo);

  const [value, setValue] = useState(existing);
  const valid = isValidProjectorSerial(value);

  return (
    <SerialStepForm
      label="Projector serial number"
      helperText={`On the projector's own label — not the Artome device. Usually ${PROJECTOR_SERIAL_MIN} to ${PROJECTOR_SERIAL_MAX} characters.`}
      image={sernoImage}
      imageAlt="Location of the projector serial number label"
      value={value}
      onChange={setValue}
      valid={valid}
      errorText={`Enter ${PROJECTOR_SERIAL_MIN} to ${PROJECTOR_SERIAL_MAX} letters or digits, with no spaces.`}
      onSubmit={() => {
        setEpsonSerial(value.trim().toUpperCase());
        navigate(paths.registerOwner);
      }}
      onBack={() => navigate(paths.registerSerial)}
    />
  );
}
